require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./health-savings-accounts-for-employees.json") })
        }
      }, "path---health-savings-accounts-for-employees");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---health-savings-accounts-for-employees!./.cache/json/health-savings-accounts-for-employees.json
// module id = 2640
// module chunks = 231608221292675